import React, {useRef, useCallback, useState, useLayoutEffect, useEffect} from 'react'
import useInputStore from '../store/inputStore'
import useHover from '../utils/useHover'
import * as THREE from 'three'
import useDragLineStore from '../store/dragLineStore'
import {Text, Line} from '@react-three/drei'

  const Segment = ({startPt, endPt, order}) => {
    const setEditMode = useInputStore(state => state.setEditMode)
    const setText = useInputStore(state => state.setText)
    const setPosition = useInputStore(state => state.setPosition)
    const setIndex = useInputStore(state => state.setIndex)
    const setType = useInputStore(state => state.setType)
    const dragMode = useDragLineStore(state => state.dragMode)
    const [segmentLength, setSegmentLength] = useState(0)
    const textRef = useRef()
    const [bindHover, hovered] = useHover()

    const placeText = useCallback(()=> {
      let midpt_x = (startPt[0]+ endPt[0])/2
      let midpt_y = (startPt[1]+endPt[1])/2
      let normalized_ortho_dir = new THREE.Vector3(endPt[1] - startPt[1], startPt[0] - endPt[0], 0).normalize();
      textRef.current.position.x = midpt_x - normalized_ortho_dir.x * 10
      textRef.current.position.y = midpt_y - normalized_ortho_dir.y * 10 
      textRef.current.position.z = 0
      console.log('normalized', normalized_ortho_dir)
    },[startPt, endPt])

    const changeEditMode = (e) => {
      
      e.stopPropagation()
      console.log('Change Edit')
      if (!dragMode){
        setEditMode(true)
        if (e.object._private_text){
          //Set required data for editing of text
          setText(e.object._private_text)
          // setAttributes({ position:e.point.toArray(), index:order })
          setPosition(e.point.toArray())
          setType('length')
          setIndex(order)
        }
        console.log('private text', e.object._private_text )
      }

    }

    const calcLength = useCallback(() => {
      //Calculate length of segment
      const len = (Math.sqrt(Math.pow((startPt[0] - endPt[0]),2) + Math.pow((startPt[1] - endPt[1]),2))).toFixed(0)
      setSegmentLength(len)
      console.log('len', segmentLength)
    }, [startPt, endPt])
    
    useLayoutEffect(()=>{
      calcLength();
      placeText();

    },[placeText, calcLength])

    // useEffect(() => {

    // },[])
    console.log('length',segmentLength)
    return(
      <>
        <Line
          // points={selectedPts}
          points={[startPt, endPt]}
          color="#666666"
          linewidth={3}
        />
          <Text
            onDoubleClick={changeEditMode}
            {...bindHover}
            ref={textRef}
            scale={[0.3,0.3,0.3]}
            color={hovered ? '#027DC3':'black'}
            anchorX="center"
            anchorY="middle"
            maxWidth={200}
            lineHeight={1}
            fontSize = {30}
            font="https://fonts.gstatic.com/s/raleway/v14/1Ptrg8zYS_SKggPNwK4vaqI.woff"
            letterSpacing={0.02}
            textAlign={'right'}
          >
            {segmentLength}
          </Text>
      </>
    )
  }



export default Segment
